/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import Loader from '../loaders/loader'
import queryParams from '../BaseComponent/QueryParams'
import Select from 'react-select'
import http from '../../Component/Interceptor/Interseptor'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Sort from '../Pagination/Sort'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import cookie from 'react-cookies'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import {Checkbox, message, Icon} from 'antd'

class ParcelLabel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      drivers: [],
      printInfo: [],
      DriversCount: 0,
      cartStations: [],
      cartStationsList: [],
      sortBy: 'orderId_asc',
      dateMin: null,
      dateMax: null,
      date: moment(),
      defaultValueDate: true,
      items: [],
      driverId: '',
      cartStationId: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جایگاه',
          value: 'carStationTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'رساننده',
          value: 'driver',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه سفارش',
          value: 'orderId',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  createFilter = () => {
    let filter = {}
    let {date} = this.state
    let driverId = this.state.driverId === null || this.state.driverId === '' ? '' : this.state.driverId.personId
    let cartStation =
      this.state.cartStationId === null || this.state.cartStationId === '' ? '' : this.state.cartStationId.id

    if (date) {
      filter.fromTime = this.epochFrom(date)
      filter.toTime = this.epochTo(date)
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    if (cartStation !== '') {
      filter.cartStationId = cartStation
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_CART_INVOICES_JASON}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              items: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = async () => {
    var css = '@page { size:A5 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    window.print()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    this.getDrivers()
    this.getCartStations()
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
  }
  async filter() {
    if (this.state.date === null) {
      message.error('تاریخ الزامی است')
    } else {
      await this.getReport()
    }
  }

  getDrivers = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getCartStations = () => {
    return http
      .get(`cartStation/list`, {})
      .then((response) => {
        if (response.data.error == null) {
          var carts = response.data.object
          for (let i = 0; i < carts.length; i++) {
            carts[i]['value'] = carts[i].id
            carts[i]['label'] = carts[i].id + ' - ' + carts[i].title
          }
          this.setState({
            cartStationsList: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (date) => {
    this.setState({
      date
    })
  }

  selectedDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  selectCartStation = (cartStationId) => {
    this.setState({
      cartStationId
    })
  }

  render() {
    let {loading} = this.state
    let columns = ['ردیف', 'جایگاه', 'رساننده', 'شناسه سفارش', '']
    return (
      <div className="rtl printA4Page mx-3">
        <Loader show={loading} />
        <div className="printSection1">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <thead>
              <tr>
                <td colSpan="100%" className="rightHeader">
                  <div className="d-flex align-items-center justify-content-between">
                    <div style={{fontWeight: '600'}}>
                      {'تاریخ گزارش گیری : ' + jMoment().format('jYYYY/jM/jD HH:mm')}
                    </div>
                    <h3 style={{fontWeight: '900'}}>{'گزارش جمع آوری سفارشهای جایگاه'}</h3>
                    <div style={{fontWeight: '600'}}>{'گزارش گیرنده : ' + cookie.load('name')}</div>
                  </div>
                </td>
              </tr>
              <tr id="firstRowPrint">
                {columns.map((col, index) => (
                  <td className="borderHeader">{col}</td>
                ))}
              </tr>
            </thead>

            <tbody>
              {this.state.items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.carStationTitle}</td>
                  <td>
                    {item.driverFirstName} {item.driverLastName}{' '}
                  </td>
                  <td>{item.orderId}</td>
                  <td>
                    <Checkbox />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش جمع آوری سفارشهای جایگاه</li>
          </ul>
        </div>

        <div className="noPrint">
          <div className="basketFilterComponent">
            <div className="filterInputs">
              <div className="formComponent">
                <label className="font-weight-bold">
                  تاریخ :<span className="requireFiled font-weight-bold">*</span>
                </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    inline
                    okLabel="تأیید"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    cancelLabel="لغو"
                    labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                    value={this.state.date}
                    id="date"
                    onChange={this.handleDateChange}
                    TextFieldComponent={this.date}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="formComponent">
                <label>رساننده</label>
                <Select
                  value={this.state.driver}
                  onChange={this.selectedDriver}
                  options={this.state.drivers}
                  isClearable={true}
                  placeholder=""
                />
              </div>

              <div className="formComponent">
                <label>جایگاه</label>
                <Select
                  value={this.state.cartStationId}
                  onChange={this.selectCartStation}
                  options={this.state.cartStationsList}
                  isClearable={true}
                  placeholder=""
                />
              </div>
            </div>
            <div className="filterOption">
              <button disabled={loading} className="confirmFilter" onClick={this.filter.bind(this)}>
                جست و جو
              </button>

              <button
                disabled={this.state.items.length === 0}
                className="printButton mt-0"
                onClick={() => this.exportPrint()}
              >
                چاپ
              </button>
            </div>
          </div>

          {this.state.items.length > 0 ? (
            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.carStationTitle}</td>
                      <td>
                        {item.driverFirstName} {item.driverLastName}{' '}
                      </td>
                      <td>{item.orderId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default ParcelLabel
